// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"25":"5f940bab","144":"5a8ddd18","263":"9a570363","420":"3147b835","501":"dbb6865b","541":"b06e8e32","871":"5abe3569","877":"31e04d59","898":"2da7f3bc","963":"24a6700e"}[chunkId] + ".js";
};